
    import { Component, Vue } from 'vue-facing-decorator';
    import { confirmState, answerConfirm } from '@/plugins/confirm';

    @Component
    export default class ConfirmDialog extends Vue {
        get state() {
            return confirmState;
        }

        answer(value: boolean) {
            answerConfirm(value);
        }
    }
